export default () => ({
  root: {
    '& [class*="HoiPoi__Label__root"]': {
      textAlign: 'left'
    }
  }
});